// Auto-generated translation for hu.
// Source: landings.js, translated via Claude Sonnet on 2026-05-26T11:22:22.594130+00:00.

export const LANDINGS = {
  "eigen-paard": {
    slug: "eigen-paard",
    eyebrow: "Lótulajdonosoknak",
    title: "Minden a lovadért. Egy appban.",
    subtitle: "Kezeld az egészséget, az edzést, a tervezést és a szakembereket egyetlen áttekinthető dossziéból.",
    primaryCTA: {
      label: "Indítás ingyen",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Premium megtekintése",
      href: "/premium",
    },
    heroScreenshot: {
      url: "/assets/owner-horse.png",
      alt: "Lóprofil — súly, oltás, EquiCoach, takarmányozás és edzés egy képernyőn",
      caption: "A lovad, teljesen átláthatóan.",
    },
    problem: "Valószínűleg most szétszórva tartod a találkozókat, fotókat, edzést, takarmányozást és egészségügyi adatokat — WhatsApp-csoportokban, cipősdobozokban és különálló appokban. Így elvész az áttekintés.",
    solution: "Az EquiSight egyetlen teljes digitális dossziévá alakítja a lovadról szóló összes adatot, amely mindig veled van.",
    benefits: [
      "Egy teljes lóprofil lovanként",
      "Egészség, patkolókovács, fogorvos és fizioterapeuta egy helyen",
      "Naptár okos emlékeztetőkkel",
      "Fotók, jegyzetek és előzmények korlát nélkül",
      "Összes adatod biztonsági mentése Premium esetén",
    ],
    pricing: {
      tiers: [
        {
          name: "Basic",
          price: "€0",
          note: "1 ló · mindig ingyenes",
        },
        {
          name: "Premium",
          price: "€4,99",
          note: "Több ló + biztonsági mentés",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Készen állsz az indulásra?",
      title: "Kezdj el ma az első lovaddal.",
      href: "/#waitlist",
    },
  },
  "premium": {
    slug: "premium",
    eyebrow: "Premium",
    title: "Több ló. Több áttekintés. Több biztonság.",
    subtitle: "Frissíts Premiumra, és kezeld az összes lovadat korlátozások nélkül — a teljes EquiCoach intelligenciával.",
    primaryCTA: {
      label: "Kezdj 14 napos ingyenes próbát",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Összes ár",
      href: "/#pricing",
    },
    audience: "Tulajdonosok, versenyzők és lótartók számára, akiknek több lovuk van.",
    features: [
      "Korlátlan számú ló hozzáadása",
      "Teljes előzmények lovanként",
      "Adatmentés",
      "Részletes EquiCoach elemzések",
      "Okos értesítések és tervezés",
      "Egészség és edzés teljes körű összekapcsolása",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Napi kevesebb mint €0,17",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Készen állsz?",
      title: "Frissíts Premiumra.",
      href: "/#waitlist",
    },
  },
  "manege-ruiter": {
    slug: "manege-ruiter",
    eyebrow: "Lovardai lovasoknak",
    title: "Fejlődj, még saját ló nélkül is.",
    subtitle: "Kövesd óráidat, edzéseidet és fejlődésedet az EquiSight-on belül — havonta kevesebbe kerül, mint egy csésze kávé apának vagy anyának. Vagy egy gombóc fagylalt tejszínhabbal.",
    primaryCTA: {
      label: "Kezdés Premiummal",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Hogyan működik?",
      href: "#features",
    },
    problem: "Lovardai lovasként általában nincs saját lovad, mégis fejlődni szeretnél, és átlátható képet akarsz kapni az óráidról, céljaidról és azokról a lovakról, amelyeken lovagolsz.",
    solution: "A lovardai funkciók alapból benne vannak a Premiumban — kövesd saját fejlődésedet, és tekintsd meg a kapcsolódó lovardai lovakat csak olvasható módban.",
    features: [
      "Edzések naplózása",
      "Célok kitűzése",
      "Fejlődés nyomon követése",
      "Lovardai lovak megtekintése névvel és fotóval",
      "Privát egészségügyi adatokhoz nincs hozzáférés",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Havonta · lovardai funkciók belefoglalva",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Csatlakozz",
      title: "Kezdj lovardai lovasként.",
      href: "/#waitlist",
    },
  },
  "manege-module": {
    slug: "manege-module",
    eyebrow: "Lovardák és istállók számára",
    title: "Tedd lovasdádat digitálisan elérhetővé minden lovas számára.",
    subtitle: "Adj lovakhoz, leckékhez és fejlődéshez kötődést a lovasoknak — anélkül, hogy érzékeny istállóadatokat osztanál meg.",
    primaryCTA: {
      label: "Hozzáférés igénylése",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Modulok megtekintése",
      href: "#features",
    },
    audience: "Az EquiSight segít a lovardáknak és istállóknak abban, hogy a lovasokat tovább bevonják, és digitálisan kitűnjenek a versenytársak közül.",
    features: [
      "Lovardai lovak láthatóvá tétele a lovasok számára",
      "Név és fotó lovanként",
      "Lovasok összekapcsolása lovakkal",
      "Csak olvasási hozzáférés az adatvédelmi szempontból érzékeny adatokhoz",
      "Lecke- és edzéstörténet egy helyen",
      "Szerepkörökkel rendelkező felhasználókezelés",
    ],
    benefits: [
      "Erősebb kötődés a lovasokhoz",
      "Professzionálisabb megjelenés",
      "Extra digitális szolgáltatás a tagok számára",
      "Új bevételi forrás az alkalmazás-használaton keresztül",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Havonta · lovardai funkciók lovasok számára is beleértve",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Készen állsz?",
      title: "Aktiváld a Lovarda Modult.",
      href: "/#waitlist",
    },
  },
  "fokkerij": {
    slug: "fokkerij",
    eyebrow: "Tenyésztési modul",
    title: "Teljes kontroll a ciklus, a vemhesség és a csikófejlődés felett.",
    subtitle: "A teljes tenyésztési modul kancatartók és tenyésztők számára — a fedeztetéstől a csikóig, egyetlen idővonalban.",
    primaryCTA: {
      label: "Tenyésztési modul aktiválása",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Funkciók megtekintése",
      href: "#features",
    },
    audience: "Tenyésztők, kancatartók és istállók számára, akik több kancát kezelnek.",
    features: [
      "Ciklus követése",
      "Tüzelés rögzítése",
      "Inszeminációs adatok rögzítése",
      "Visszaszámlálás az ultrahangvizsgálatokig",
      "Vemhességi ellenőrzések tervezése",
      "Törzsfák és leszármazás",
      "Csikófejlődés nyomon követése",
      "Az összes vemhes kanca áttekintése",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Havonta · A tenyésztési modul a Pro csomagban szerepel",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Kezdje el még ma",
      title: "Kezdje el a tenyésztéskezelést.",
      href: "/#waitlist",
    },
  },
  "hoefsmid": {
    slug: "hoefsmid",
    eyebrow: "Patkolókovács modul",
    title: "Dolgozz okosabban patkolókovácként. Rögzíts mindent professzionálisan.",
    subtitle: "Naptár, fotók, megjegyzések és kezelési előzmények egy modulban — kevesebb félreértés, erősebb dokumentáció.",
    primaryCTA: {
      label: "Kezdés patkolókovácként",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Professional csomag megtekintése",
      href: "/professional",
    },
    audience: "Patkolókovácoknak, akik javítani szeretnék az áttekinthetőséget, a bizonyítékkezelést és az ügyfélkommunikációt.",
    features: [
      "Saját naptár",
      "Időpontok ügyfelenként",
      "Lóprofilok megtekintése",
      "Előtte és utána fotók hozzáadása",
      "Kezelés rögzítése",
      "Tanácsok és megjegyzések dokumentálása",
      "ETA értesítés az ügyfélnek: \"A patkolókovács úton van\"",
    ],
    benefits: [
      "Professzionálisabb munkavégzés",
      "Kevesebb félreértés",
      "Jobb dokumentációépítés",
      "Erősebb pozíció felelősség esetén",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Havonta · A patkolókovács modul a Professional csomagban szerepel",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Készen állsz?",
      title: "Aktiváld a Patkolókovács modult.",
      href: "/#waitlist",
    },
  },
  "paardentandarts": {
    slug: "paardentandarts",
    eyebrow: "Fogorvosi modul",
    title: "Teljes fogászati nyilvántartás lovanként.",
    subtitle: "Rögzítse a leleteket, kezeléseket és utánkövetést közvetlenül az EquiSight-ban.",
    primaryCTA: {
      label: "Indítás lófogorvosként",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Tekintse meg a Professional csomagot",
      href: "/professional",
    },
    audience: "Lófogorvosok, állatorvosok és praxisok, akik strukturáltan szeretnének dolgozni.",
    features: [
      "Fogvizsgálat rögzítése",
      "Leletek kezelésenként",
      "Fotók hozzáadása",
      "Jelentés a tulajdonosnak",
      "Utánkövetési javaslat",
      "Előzmények lovanként",
      "Új időpont tervezése",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Havonta · A fogorvosi modul a Professional csomagban szerepel",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Készen áll?",
      title: "Aktiválja a Fogorvosi modult.",
      href: "/#waitlist",
    },
  },
  "fysio-osteo": {
    slug: "fysio-osteo",
    eyebrow: "Fizió / Oszteopata modul",
    title: "Kövesse nyomon a testet, a mozgást és a felépülést professzionálisan.",
    subtitle: "Fizioterapeuták és oszteopaták számára, akik strukturáltan szeretnék kísérni a lovakat.",
    primaryCTA: {
      label: "Kezdés fizióként/oszteopatáként",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Tekintse meg a Professional csomagot",
      href: "/professional",
    },
    features: [
      "Bevitel lovanként",
      "Testi leletek rögzítése",
      "Fotók és videók hozzáadása",
      "Kezelési jelentés készítése",
      "Gyakorlatok és nyomon követés megosztása",
      "Felépülési folyamat követése",
      "Lovanként teljes előzmény",
    ],
    benefits: [
      "Jobb áttekintés az idő múlásával",
      "Professzionális jelentéskészítés",
      "Egyértelmű kommunikáció a tulajdonossal, az edzővel és a lovassal",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Havonta · A Fizió / Oszteopata modul a Professional csomagban szerepel",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Készen áll?",
      title: "Aktiválja a Fizió / Oszteopata modult.",
      href: "/#waitlist",
    },
  },
  "trainer": {
    slug: "trainer",
    eyebrow: "Edzői modul",
    title: "Eddzél lovasokat adatokkal, célokkal és fejlődéssel.",
    subtitle: "Tedd mérhetővé az edzést és professzionálisabbá a felkészítést — egy vagy több lovas számára.",
    primaryCTA: {
      label: "Kezdés edzőként",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Pro csomag megtekintése",
      href: "/#pricing",
    },
    audience: "Oktatók, edzők és coachok számára, akiknek több lovasuk vagy lovuk van.",
    features: [
      "Lovasok összekapcsolása",
      "Lovak követése",
      "Edzési célok meghatározása",
      "Visszajelzés adása",
      "Versenyeredmények elemzése",
      "Fejlődés megtekintése páronként",
      "Protokollelemzések használata az edzési fókuszhoz",
    ],
    benefits: [
      "Jobb felkészítés",
      "Több struktúra",
      "Professzionálisabb kommunikáció",
      "Erősebb ügyfélkapcsolat",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Havonta · Az edzői modul a Pro csomagban szerepel",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Készen állsz?",
      title: "Aktiváld az edzői modult.",
      href: "/#waitlist",
    },
  },
  "wedstrijdanalyse": {
    slug: "wedstrijdanalyse",
    eyebrow: "Versenyanalízis",
    title: "A jegyzőkönyvtől a teljesítményjavításig.",
    subtitle: "Töltsd fel a versenyprotokollodat, és fedezd fel, hol hagysz pontokat az asztalon — ne csak a pontszámodat nézd, hanem értsd meg, hogyan fejlődhetsz.",
    primaryCTA: {
      label: "Elemezd az első protokollodat",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Tekintsd meg a Premiumot",
      href: "/premium",
    },
    features: [
      "Protokollfotó feltöltése",
      "Elő- és hátlap feldolgozása",
      "Osztály, feladatszám és bíró felismerése",
      "Részenkénti pontszámelemzés",
      "Megjegyzések összefoglalása",
      "Erősségek és gyengeségek megjelenítése",
      "Trendek ló-lovas kombinációnként",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Havonta · versenyanalízis a Premiumtól felfelé tartalmazza",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Készen állsz?",
      title: "Kezdj el versenyanalízist végezni.",
      href: "/#waitlist",
    },
  },
  "professional": {
    slug: "professional",
    eyebrow: "Professional csomag",
    title: "Lovakkal foglalkozó szakembereknek.",
    subtitle: "Patkovács, fogorvos, fizioterapeuta, oszteopata vagy edző: dolgozzatok együtt egyetlen digitális lódosszéban.",
    primaryCTA: {
      label: "Kezdés szakemberként",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Tekintse meg az egyes modulokat",
      href: "#features",
    },
    audience: "A Professional csomag egyetlen előfizetésbe foglalja össze az összes szakmai modult.",
    features: [
      "Patkovács modul",
      "Fogorvos modul",
      "Fizioterapeuta / Oszteopata modul",
      "Naptár és ügyfélkezelés",
      "Lóprofilok és jelentések",
      "Kezelési előzmények és dosszié összeállítása",
      "Kommunikáció a tulajdonossal",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Havonta · minden szakmai modul beleszámítva",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Készen áll?",
      title: "Válassza a Professionalt.",
      href: "/#waitlist",
    },
  },
  "noodnummerpaard": {
    slug: "noodnummerpaard",
    eyebrow: "Ló sürgősségi számok",
    title: "Mindig a megfelelő segítség kéznél.",
    subtitle: "Vészhelyzetben minden másodperc számít. Az EquiSight segítségével lovad összes fontos elérhetősége azonnal kéznél van — egy érintés és már hívod is.",
    primaryCTA: {
      label: "Állítsd be a vészkontaktjaidat",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Kezdd el ingyen az EquiSight-tal",
      href: "/#waitlist",
    },
    accent: "danger",
    heroScreenshot: {
      url: "/assets/emergency.png",
      alt: "Vészkontaktok — közvetlen hívás, WhatsApp üzenet vagy navigáció az állatorvoshoz, klinikához és patkókovácshoz",
      caption: "Egy érintés. Semmi pánikszerű keresgélés.",
      embeddedFrame: true,
    },
    problem: "Valami van a lovaddal — kólika, sérülés, pánik. És akkor elkezdődik a keresés. Kit hívj? Megvan a megfelelő szám? Ez az ügyeleti szám? Értékes idő vész el.",
    solution: "Az EquiSight-tal minden azonnal kéznél van. Semmi keresgélés. Semmi bizonytalanság. Egy érintés és felveszel a kapcsolatot.",
    scenario: {
      title: "Képzeld el — lovad kólika tüneteket mutat.",
      steps: [
        "Megnyitod az EquiSight-ot",
        "Rákattintasz az \"Állatorvos\" gombra",
        "Azonnal hívod",
      ],
      tagline: "Semmi stressz. Semmi keresgélés. Csak cselekvés.",
    },
    features: [
      "Minden sürgősségi szám egy helyen",
      "Egy érintéses hívás az appból",
      "WhatsApp üzenet egy érintéssel",
      "Közvetlen navigáció a címre",
      "Lovanként saját kontaktlista",
      "Állatorvos, klinika, patkókovács, fogorvos, fizioterapeuta",
      "Cím és útvonalleírás azonnal elérhető",
      "Kedvenc számok megjelölése csillaggal",
      "Sürgősségi számok (112, 144) mindig felül",
    ],
    benefits: [
      "Nyugalom és kontroll vészhelyzetben",
      "Az istálló minden dolgozója ugyanazokkal a számokkal rendelkezik",
      "Nem vesznek el többé névjegykártyák",
      "Másodpercekkel gyorsabb reakció sürgős esetben",
    ],
    audience: "Lótulajdonosok, gondozók, edzők és istállók számára — mindenki számára, aki felelős egy lóért.",
    showcase: {
      eyebrow: "Előre beállítva neked",
      title: "13 kategória kontakt — készen a kitöltésre.",
      description: "Az állatorvostól és sürgősségi klinikától a nyeregtáskásig, oktatóig és legelőkezelőig. Az EquiSight ismeri a te világodat, és előre elkészíti a megfelelő kontaktmezőket. Érintsd meg, töltsd ki, kész.",
      bullets: [
        "Sürgősség és egészség — állatorvos, sürgősség, klinika, mérgezési vonal",
        "Napi gondozás — patkókovács, fogorvos, fizioterapeuta, oktató",
        "Istálló és legelő — istállótulajdonos, legelőkezelő, panzió",
        "Takarmány és felszerelés — széna, abraks, szalmaszállítók",
      ],
      image: {
        url: "/assets/emergency-manage.png",
        alt: "Vészkontakt kezelő képernyő — az összes javasolt kontakt kategóriánként",
        embeddedFrame: true,
      },
    },
    checklist: {
      title: "Ló sürgősségi számok ellenőrzőlista",
      items: [
        "Állatorvos",
        "Sürgősségi klinika (24/7)",
        "Állatmentő · 144",
        "Patkókovács",
        "Tartalék kapcsolattartó személy",
        "Általános segélyhívó szám · 112",
      ],
      cta: {
        label: "Nyisd meg az EquiSight-ban és töltsd ki azonnal",
        href: "/#waitlist",
      },
    },
    pricing: {
      tiers: [
        {
          name: "Sürgősségi számok",
          price: "Gratis",
          note: "Mindig ingyenes · mindenki számára, minden előfizetésben",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Gondoskodj arról, hogy felkészült legyél",
      title: "Mielőtt szükség lenne rá.",
      href: "/#waitlist",
    },
    microcopy: [
      "Semmi kötelezettség",
      "2 percen belül beállítva",
      "Bármikor módosítható",
    ],
  },
};

export default LANDINGS;
